export const CLEAR_STATE = "rebooking/CLEAR_STATE";
export const SELECT_REBOOKING = "rebooking/SELECT_REBOOKING";

export const GET_ALL_REBOOKING_REQUEST = "rebooking/GET_ALL_REBOOKING_REQUEST";
export const GET_ALL_REBOOKING_SUCCESS = "rebooking/GET_ALL_REBOOKING_SUCCESS";
export const GET_ALL_REBOOKING_FAILURE = "rebooking/GET_ALL_REBOOKING_FAILURE";

export const SHOW_LOADING = "rebooking/SHOW_LOADING";
export const HIDE_LOADING = "rebooking/HIDE_LOADING";

export const GET_ALL_PATIENT_REBOOKING_REQUEST =
  "rebooking/GET_ALL_PATIENT_REBOOKING_REQUEST";
export const GET_ALL_PATIENT_REBOOKING_SUCCESS =
  "rebooking/GET_ALL_PATIENT_REBOOKING_SUCCESS";
export const GET_ALL_PATIENT_REBOOKING_FAILURE =
  "rebooking/GET_ALL_PATIENT_REBOOKING_FAILURE";

export const GET_REBOOKING_BY_PATIENT_ID =
  "rebooking/GET_REBOOKING_BY_PATIENT_ID";

export const GET_ALL_REBOOKING_FROM_HISTORY =
  "rebooking/GET_ALL_REBOOKING_FROM_HISTORY";
